/**
 * The client-side row sort behind `DataTable` and `orderRows`.
 *
 * @module components/ui/sort-rows
 */

import type { Column } from "./DataTable";

/**
 * Sort a copy of the rows. Nulls sort last in either direction, because a
 * missing value is not smaller than a present one, it is absent.
 */
export function sortRows<Row>(
  rows: readonly Row[],
  column: Column<Row> | undefined,
  direction: "asc" | "desc",
): readonly Row[] {
  if (!column?.sortValue) {
    return rows;
  }
  const read = column.sortValue;
  return [...rows].sort((left, right) => {
    const a = read(left);
    const b = read(right);
    if (a === null && b === null) {
      return 0;
    }
    if (a === null) {
      return 1;
    }
    if (b === null) {
      return -1;
    }
    const order =
      typeof a === "number" && typeof b === "number" ? a - b : String(a).localeCompare(String(b));
    return direction === "asc" ? order : -order;
  });
}
